// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_DadosDaFranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * GET /implantacao/dados/:franquia_id e os POSTs que gravam — os dados da unidade e os
 * bancários da franquia, para o franqueado preencher (chamado NS 2026-0079, F2).
 */
import type { Implantacao_DadosBancariosRow } from './Implantacao_DadosBancariosRow'
import type { Implantacao_DadosFranquiaRow } from './Implantacao_DadosFranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Implantacao_DadosDaFranquiaResponseDados {
franquia_id: number
franquia: Implantacao_DadosFranquiaRow
bancarios: Implantacao_DadosBancariosRow
}

export type Implantacao_DadosDaFranquiaResponse = ApiResponse<Implantacao_DadosDaFranquiaResponseDados>;

registerResponseContract('Implantacao_DadosDaFranquiaResponse', {
  franquia_id: { type: 'number',  required: true },
  franquia: {
    type: 'object',
    required: true,
    fields: {
      nome_fantasia:      { type: 'string',  required: false },
      cnpj:               { type: 'string',  required: false },
      inscricao_estadual: { type: 'string',  required: false },
      telefone:           { type: 'string',  required: false },
      cep:                { type: 'string',  required: false },
      endereco:           { type: 'string',  required: false },
      numero:             { type: 'string',  required: false },
      complemento:        { type: 'string',  required: false },
      bairro:             { type: 'string',  required: false },
      cidade:             { type: 'string',  required: false },
      estado:             { type: 'string',  required: false },
    },
  },
  bancarios: {
    type: 'object',
    required: true,
    fields: {
      banco:             { type: 'string',  required: false },
      agencia:           { type: 'string',  required: false },
      conta:             { type: 'string',  required: false },
      tipo_conta:        { type: 'string',  required: false },
      titular:           { type: 'string',  required: false },
      documento_titular: { type: 'string',  required: false },
      pix:               { type: 'string',  required: false },
    },
  },
})
